<!--
2023-05-24 Matt 常态化流水返利活动规则，读取静态文件内容
-->
<template>
  <div class="RulePage">
    <TopBack :title="$t('lang.betActivityRegularly.rules')" />

    <img
      class="introduceImg"
      alt="agent-rules"
      src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/betting_activity/betting_activity_regularly_banner_20230524.png"
    >

    <div class="rules" v-html="ruleHtml">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import request from '@/service'
import TopBack from '@/components/TopBack/index'

export default {
  name: 'BetActivityRegularlyRule',
  components: {
    TopBack
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      ruleHtml: ''
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData: async function () {
      let data = {UserId: null}
      if (this.userInfo) {
        data = {UserId: this.userInfo.UserId}
      }
      let formulaHtml = ''
      await request('post', 'innovation/activity-normal/get-reward-formula', data).then(res => {
        if (res !== null) {
          res.forEach(element => {
            let gameCatetory = element.GameCatetory
            if (this.$store.state.locale !== 'EN') {
              // 如果不是英语，翻译一下
              switch (gameCatetory) {
                case 'LiveCasino':
                  gameCatetory = this.$t('lang.label.live')
                  break
                case 'Lottery':
                  gameCatetory = this.$t('lang.label.lottery')
                  break
                case 'Card':
                  gameCatetory = this.$t('lang.label.card')
                  break
                case 'Fishing':
                  gameCatetory = this.$t('lang.label.fishing')
                  break
                case 'Slot':
                  gameCatetory = this.$t('lang.label.slots')
                  break
                case 'Sports':
                  gameCatetory = this.$t('lang.label.sports')
                  break
                default:
                  break
              }
            } else if (this.$store.state.locale === 'EN') {
              // 如果不是英语，翻译一下
              switch (gameCatetory) {
                case 'LiveCasino':
                  gameCatetory = this.$t('lang.label.live')
                  break
                case 'Lottery':
                  gameCatetory = this.$t('lang.label.lottery')
                  break
                case 'Card':
                  gameCatetory = this.$t('lang.label.card')
                  break
                case 'Fishing':
                  gameCatetory = this.$t('lang.label.fishing')
                  break
                case 'Slot':
                  gameCatetory = this.$t('lang.label.slots')
                  break
                case 'Sports':
                  gameCatetory = this.$t('lang.label.sports')
                  break
                default:
                  break
              }
            }

            formulaHtml += '<tr style="border-bottom: #686868 solid 1px"><td style="text-align: center">' + gameCatetory + '</td><td style="text-align: center">' + element.Rewards + '%</td>    </tr>'
          })
        }
      })
      let languagePre = this.$store.state.locale
      languagePre = languagePre === 'EN' ? '' : '-' + languagePre
      const htmlFileURL = location.origin + '/static/promotionRules/BetActivityRegularly-' + this.$store.state.internation + languagePre + '.html'
      axios.get(htmlFileURL).then(res => {
        if (res.data != null) {
          let htmlDate = ''
          htmlDate = res.data
          this.ruleHtml = htmlDate.replace('Reward-details', formulaHtml)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .RulePage {
    padding:56px 0 70px 0;
    background-color: rgba(0,0,0,.9);
    height: 92vh;
    overflow-y: hidden;
    text-align: center;

    .introduceImg {
      width: 90vw;
      margin: 20px auto 0;
      border-radius: 5px;
    }

    .rules {
      height: 70vh;
      width: 90vw;
      margin: 5px auto 20px;
      padding-bottom: 220px;
      overflow-y: scroll;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/BetActivityRegularly/rules.vue